<div class="white-box section-details">
  <h4>
    {{ 'steps.id5.account_to_fund.maximum_contribution_box.title' | translate: { year: currentYear } }}
  </h4>
  <p
    class="msg"
    *ngIf="showUnemployed3ANote"
    [innerHTML]="
      'steps.id5.account_to_fund.maximum_contribution_box.smallContribution_unemployed_AHV_income'
        | translate
          : {
              maximalContribution: maximumContributionAmount | translateNumber: customerData.language:currentAccount.currency
            }
    "
  ></p>
  <ng-container *ngIf="!accountOpened; else accountIsOpened">
    <p *ngIf="!showUnemployed3ANote">
      {{
        'steps.id5.account_to_fund.maximum_contribution_box.' + maximumContributionLevel + 'Contribution'
          | translate
            : {
                maximalContribution: maximumContributionAmount | translateNumber: customerData.language:currentAccount.currency
              }
      }}
    </p>
  </ng-container>
  <ng-template #accountIsOpened>
    <p *ngIf="!showUnemployed3ANote" class="strong">
      {{ maximumContributionAmount | translateNumber: customerData.language:currentAccount.currency }}
    </p>
  </ng-template>
  <p class="notice">
    {{
      'minimumInvestmentNote.full.inyova3a'
        | translate: { '3aMinimumInvestmentAmount': MINIMUM_INVESTMENT | translateNumber: customerData.language:currentAccount.currency }
    }}
  </p>
</div>
